import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from '../menu'
import errores from '../../middleware/errordb'
import back from '../../back.svg';
import config from '../../config';
//import funciones from '../../middleware/funciones';
import Mensajes from '../subcomponent/mensajes';
//import Modal from '../subcomponent/modal';
//import Vendedores from '../usuarios';
import ModalConfirm from '../subcomponent/modalConfirm';

class Formularioclientes extends Component {
    constructor(props) {
        super(props);
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        this.state = {
            titulo: "Crear Clientes",
            msg: 0,
            comp: "",
            id_clientes: "",
            empresa: currentCompany,
            ID_EMPRESA: currentCompany,
            TIPO_IDENTIFICACION: "",
            DOCUMENTO_CLIENTE: "",
            DV_CLIENTE: "",
            NOMBRE_CLIENTE: "",
            DIRECCION_CLIENTE: "",
            CODIGO_POSTAL: "",
            CODIGO_DEPARTAMENTO_CLIENTE: "",
            NOMBRE_DEPARTAMENTO_CLIENTE: "",
            CODIGO_CIUDAD_CLIENTE: "",
            NOMBRE_CIUDAD_CLIENTE: "",
            TELEFONO_FIJO_CLIENTE: "",
            EMAIL_CLIENTE: "",
            TIPO_TERCERO: "",
            NOMBRE_ESTABLECIMIENTO: "",
            BARRIO_CLIENTE: "",
            TELEFONO_CELULAR_CLIENTE: "",
            CIIU: "",
            ESTADO_CLIENTE: "1",
            VENDEDOR_ASOCIADO: "",
            CONTACTO_COMPRA: "",
            GRAN_CONTRIBUYENTE: "1",
            LISTA_CLIENTE: "",
            FORMA_PAGO_CLIENTE: "",
            LIQUIDA_IVA: "1",
            LIQUIDA_RENTA: "1",
            LIQUIDA_RETEIVA: "1",
            LIQUIDA_RETEICA: "1",
            LIQUIDA_RETEOTROS: "1",
            OBSERVACIONES_CLIENTE: "",
            ADDITIONA_EMAIL:"",
            vendedores: [],
            ciudades: [],
            departamentos: [],
            listas: [],
            forma_pago: [],
            tipo: currentUserType,
            mostrarMensaje: false,
            mensaje: "",
            O13: false,
            O15: false,
            O23: false,
            O47: false,
            R99: false,
            REGIMEN: "",
            RESPONSABILIDAD: "",
            mensajeConfirm: " "
        }
    }

    componentDidMount() {
        const { search } = this.props.location;
        let titulo = "";
        let id_clientes = "";
        const categoriaEdicion = search.replace('?', '');
        if (categoriaEdicion) {
            titulo = "Modificar Clientes";
            id_clientes = categoriaEdicion;
        } else {
            titulo = "Crear Clientes";
            id_clientes = "0";
        }
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa,
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/clients/' + id_clientes, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datosAll = data.data;
                    const datos = datosAll[0];
                    const vendedores = datosAll[1];
                    const ciudades = datosAll[2];
                    const departamentos = datosAll[3];
                    const listas = datosAll[4];
                    const forma_pago = datosAll[5];
                    this.setState({
                        //descripcion: datos[0]["CODIGO_EMPRESA"],
                        ID_CLIENTES: (id_clientes === "0") ? "" : datos[0]["ID_CLIENTES"],
                        //ID_EMPRESA: (id_clientes === "0")?"": datos[0]["ID_EMPRESA"],
                        TIPO_IDENTIFICACION: (id_clientes === "0") ? "" : datos[0]["TIPO_IDENTIFICACION"],
                        DOCUMENTO_CLIENTE: (id_clientes === "0") ? "" : datos[0]["DOCUMENTO_CLIENTE"],
                        DV_CLIENTE: (id_clientes === "0") ? "" : datos[0]["DV_CLIENTE"],
                        NOMBRE_CLIENTE: (id_clientes === "0") ? "" : datos[0]["NOMBRE_CLIENTE"],
                        DIRECCION_CLIENTE: (id_clientes === "0") ? "" : datos[0]["DIRECCION_CLIENTE"],
                        CODIGO_POSTAL: (id_clientes === "0") ? "" : datos[0]["CODIGO_POSTAL"],
                        CODIGO_DEPARTAMENTO_CLIENTE: (id_clientes === "0") ? "" : datos[0]["CODIGO_DEPARTAMENTO_CLIENTE"],
                        NOMBRE_DEPARTAMENTO_CLIENTE: (id_clientes === "0") ? "" : datos[0]["NOMBRE_DEPARTAMENTO_CLIENTE"],
                        CODIGO_CIUDAD_CLIENTE: (id_clientes === "0") ? "" : datos[0]["CODIGO_CIUDAD_CLIENTE"],
                        NOMBRE_CIUDAD_CLIENTE: (id_clientes === "0") ? "" : datos[0]["NOMBRE_CIUDAD_CLIENTE"],
                        TELEFONO_FIJO_CLIENTE: (id_clientes === "0") ? "" : datos[0]["TELEFONO_FIJO_CLIENTE"],
                        EMAIL_CLIENTE: (id_clientes === "0") ? "" : datos[0]["EMAIL_CLIENTE"],
                        TIPO_TERCERO: (id_clientes === "0") ? "" : datos[0]["TIPO_TERCERO"],
                        NOMBRE_ESTABLECIMIENTO: (id_clientes === "0") ? "" : datos[0]["NOMBRE_ESTABLECIMIENTO"],
                        BARRIO_CLIENTE: (id_clientes === "0") ? "" : datos[0]["BARRIO_CLIENTE"],
                        TELEFONO_CELULAR_CLIENTE: (id_clientes === "0") ? "" : datos[0]["TELEFONO_CELULAR_CLIENTE"],
                        CIIU: (id_clientes === "0") ? "" : datos[0]["CIIU"],
                        ESTADO_CLIENTE: (id_clientes === "0") ? "1" : datos[0]["ESTADO_CLIENTE"],
                        VENDEDOR_ASOCIADO: (id_clientes === "0") ? "" : datos[0]["VENDEDOR_ASOCIADO"],
                        CONTACTO_COMPRA: (id_clientes === "0") ? "" : datos[0]["CONTACTO_COMPRA"],
                        GRAN_CONTRIBUYENTE: (id_clientes === "0") ? "1" : datos[0]["GRAN_CONTRIBUYENTE"],
                        LISTA_CLIENTE: (id_clientes === "0") ? "" : datos[0]["LISTA_CLIENTE"],
                        FORMA_PAGO_CLIENTE: (id_clientes === "0") ? "" : datos[0]["FORMA_PAGO_CLIENTE"],
                        LIQUIDA_IVA: (id_clientes === "0") ? "1" : datos[0]["LIQUIDA_IVA"],
                        LIQUIDA_RENTA: (id_clientes === "0") ? "1" : datos[0]["LIQUIDA_RENTA"],
                        LIQUIDA_RETEIVA: (id_clientes === "0") ? "1" : datos[0]["LIQUIDA_RETEIVA"],
                        LIQUIDA_RETEICA: (id_clientes === "0") ? "1" : datos[0]["LIQUIDA_RETEICA"],
                        LIQUIDA_RETEOTROS: (id_clientes === "0") ? "1" : datos[0]["LIQUIDA_RETEOTROS"],
                        OBSERVACIONES_CLIENTE: (id_clientes === "0") ? "" : datos[0]["OBSERVACIONES_CLIENTE"],
                        RESPONSABILIDAD: (id_clientes === "0") ? "" : datos[0]["RESPONSABILIDAD"],
                        REGIMEN: (id_clientes === "0") ? "" : datos[0]["REGIMEN"],
                        ADDITIONA_EMAIL: (id_clientes === "0") ? "" : datos[0]["ADDITIONA_EMAIL"],
                        vendedores,
                        departamentos,
                        ciudades,
                        listas,
                        forma_pago
                    });
                    this.validarRespo((id_clientes === "0") ? "" : (datos[0]["RESPONSABILIDAD"] || ""))

                } else {
                    this.setState({ mostrarMensaje: true, mensaje: data.message })
                }
            });

        this.setState({ id_clientes, titulo });
    }


    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({show: false});
        const { ID_EMPRESA } = this.state
        const { TIPO_IDENTIFICACION } = this.state
        const { DOCUMENTO_CLIENTE } = this.state
        const { DV_CLIENTE } = this.state
        const { NOMBRE_CLIENTE } = this.state
        const { DIRECCION_CLIENTE } = this.state
        const { CODIGO_POSTAL } = this.state
        const { CODIGO_DEPARTAMENTO_CLIENTE } = this.state
        const { NOMBRE_DEPARTAMENTO_CLIENTE } = this.state
        const { CODIGO_CIUDAD_CLIENTE } = this.state
        const { NOMBRE_CIUDAD_CLIENTE } = this.state
        const { TELEFONO_FIJO_CLIENTE } = this.state
        const { EMAIL_CLIENTE } = this.state
        const { TIPO_TERCERO } = this.state
        const { NOMBRE_ESTABLECIMIENTO } = this.state
        const { BARRIO_CLIENTE } = this.state
        const { TELEFONO_CELULAR_CLIENTE } = this.state
        const { CIIU } = this.state
        const { ESTADO_CLIENTE } = this.state
        const { VENDEDOR_ASOCIADO } = this.state
        const { CONTACTO_COMPRA } = this.state
        const { GRAN_CONTRIBUYENTE } = this.state
        const { LIQUIDA_IVA } = this.state
        const { LIQUIDA_RENTA } = this.state
        const { LIQUIDA_RETEIVA } = this.state
        const { LIQUIDA_RETEICA } = this.state
        const { LIQUIDA_RETEOTROS } = this.state
        const { OBSERVACIONES_CLIENTE } = this.state
        const { LISTA_CLIENTE } = this.state
        const { RESPONSABILIDAD } = this.state
        const { REGIMEN } = this.state
        const { FORMA_PAGO_CLIENTE } = this.state;
        const { ADDITIONA_EMAIL } = this.state;

        let ruta = "";
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                ID_EMPRESA,
                TIPO_IDENTIFICACION,
                DOCUMENTO_CLIENTE,
                DV_CLIENTE,
                NOMBRE_CLIENTE,
                DIRECCION_CLIENTE,
                CODIGO_POSTAL,
                CODIGO_DEPARTAMENTO_CLIENTE,
                NOMBRE_DEPARTAMENTO_CLIENTE,
                CODIGO_CIUDAD_CLIENTE,
                NOMBRE_CIUDAD_CLIENTE,
                TELEFONO_FIJO_CLIENTE,
                EMAIL_CLIENTE,
                TIPO_TERCERO,
                NOMBRE_ESTABLECIMIENTO,
                BARRIO_CLIENTE,
                TELEFONO_CELULAR_CLIENTE,
                CIIU,
                ESTADO_CLIENTE,
                VENDEDOR_ASOCIADO,
                CONTACTO_COMPRA,
                GRAN_CONTRIBUYENTE,
                LIQUIDA_IVA,
                LIQUIDA_RENTA,
                LIQUIDA_RETEIVA,
                LIQUIDA_RETEICA,
                LIQUIDA_RETEOTROS,
                OBSERVACIONES_CLIENTE,
                LISTA_CLIENTE,
                RESPONSABILIDAD,
                REGIMEN,
                FORMA_PAGO_CLIENTE,
                ADDITIONA_EMAIL
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }

        if (this.state.id_clientes === "0") {
            ruta = config.servBackEnd + '/clients/create';
        } else {
            ruta = config.servBackEnd + '/clients/modify/' + this.state.id_clientes;
        }
        fetch(ruta, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const nuevoImpuesto = (data.data.insertId !== 0) ? data.data.insertId : this.state.id_clientes;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", id_clientes: nuevoImpuesto })
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Clientes con errores:" + errores[data.code] + " " + data.message })
                }
            });

    }
    validarRespo = (data) => {
        const newdata = data.split(";");
        let tmpO13 = false;
        let tmpO15 = false;
        let tmpO23 = false;
        let tmpO47 = false;
        let tmpR99 = false;
        newdata.forEach(element => {
            if (element === "O-13") tmpO13 = true;
            if (element === "O-15") tmpO15 = true;
            if (element === "O-23") tmpO23 = true;
            if (element === "O-47") tmpO47 = true;
            if (element === "R-99-PN") tmpR99 = true;
        });
        this.setState({
            O13: tmpO13,
            O15: tmpO15,
            O23: tmpO23,
            O47: tmpO47,
            R99: tmpR99
        })
    }

    CheckedRespo = ({ target }) => {
        let finalString = "";
        const { id } = target;
        const { checked } = target;
        const tmpResponsabilidad = this.state.RESPONSABILIDAD.split(";");
        const confirm = tmpResponsabilidad.findIndex(function (element) {
            return element === id;
        });
        if (checked) {
            if (confirm < 0) tmpResponsabilidad.push(id);
        } else {
            if (confirm >= 0) tmpResponsabilidad.splice(confirm, 1);
        }
        tmpResponsabilidad.forEach(element => {
            if (element !== "") finalString += element + ";";
        });
        finalString = finalString.substr(0, finalString.length - 1)
        this.validarRespo(finalString);
        this.setState({ RESPONSABILIDAD: finalString })
    }
     handleClose = () => {
         this.setState({show: false});
     };

 
    render() {
        const mensajeBoton = (this.state.id_clientes === "0") ? 'Crear' : 'Modificar';
        const mensajeConfirm = (this.state.id_clientes === "0") ? '¿Esta seguro que desea crear el cliente?' : '¿Esta seguro que desea modificar el cliente?';
        const validacionUser = (this.state.tipo === '0' || this.state.tipo === '1' || this.state.tipo === '2');
        const { vendedores } = this.state
        const { ciudades } = this.state;
        const { departamentos } = this.state;
        const { listas } = this.state;
        const { forma_pago } = this.state;
        const currentDep = this.state.CODIGO_DEPARTAMENTO_CLIENTE;
        return (
            <div className="Formularioclientes">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>{this.state.titulo}</h2>
                </Jumbotron>
                {!validacionUser && <p>Usuario no valido para este modulo</p>}
                {validacionUser &&
                    <div>
                        <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Clientes!</Tooltip>}>
                            <div className="div-back">
                                <a href="/clientes/">
                                    <img src={back} className="icon" alt="" />
                                </a>
                            </div>
                        </OverlayTrigger>
                        <Card className="card">
                            <Card.Body>
                                <Form className="form" onSubmit={this.handleSubmit}>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>ID EMPRESA</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ ID_EMPRESA: e.target.value })} value={this.state.ID_EMPRESA} disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>TIPO IDENTIFICACION</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ TIPO_IDENTIFICACION: e.target.value, DV_CLIENTE: '0' })} value={this.state.TIPO_IDENTIFICACION} required >
                                                <option value="">Seleccione</option>
                                                <option value="31">NIT</option>
                                                <option value="13">CEDULA CIUDADANIA</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>DOCUMENTO CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ DOCUMENTO_CLIENTE: e.target.value })} value={this.state.DOCUMENTO_CLIENTE} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>DV CLIENTE</Form.Label>
                                            <Form.Control disabled={this.state.TIPO_IDENTIFICACION === "13"} type="text" onChange={e => this.setState({ DV_CLIENTE: e.target.value })} value={this.state.DV_CLIENTE} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>NOMBRE CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NOMBRE_CLIENTE: e.target.value.toUpperCase() })} value={this.state.NOMBRE_CLIENTE} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>DIRECCION CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ DIRECCION_CLIENTE: e.target.value.toUpperCase() })} value={this.state.DIRECCION_CLIENTE} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>CODIGO POSTAL</Form.Label>
                                            <Form.Control type="number" onChange={e => this.setState({ CODIGO_POSTAL: e.target.value })} value={this.state.CODIGO_POSTAL} />
                                        </Form.Group>
                                        {/* <Form.Group as={Col} controlId="">
                                            <Form.Label>CODIGO DEPARTAMENTO CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ CODIGO_DEPARTAMENTO_CLIENTE: e.target.value })} value={this.state.CODIGO_DEPARTAMENTO_CLIENTE} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>NOMBRE DEPARTAMENTO CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NOMBRE_DEPARTAMENTO_CLIENTE: e.target.value })} value={this.state.NOMBRE_DEPARTAMENTO_CLIENTE} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>CODIGO CIUDAD CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ CODIGO_CIUDAD_CLIENTE: e.target.value })} value={this.state.CODIGO_CIUDAD_CLIENTE} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>NOMBRE CIUDAD CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NOMBRE_CIUDAD_CLIENTE: e.target.value })} value={this.state.NOMBRE_CIUDAD_CLIENTE} />
                                        </Form.Group> */}
                                        <Form.Group as={Col} controlId="formGridDepartamento">
                                            <Form.Label>DEPARTAMENTO</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_DEPARTAMENTO_CLIENTE: e.target.value, CODIGO_CIUDAD: "", NOMBRE_DEPARTAMENTO_CLIENTE: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_DEPARTAMENTO_CLIENTE} required>
                                                <option key='d' value="">--Seleccione Departamento--</option>
                                                {departamentos.map(function (currentData, index) {
                                                    return <option key={'d' + index} value={currentData.CODIGO_DEPARTAMENTO}>{currentData.NOMBRE_DEPARTAMENTO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridCiudad">
                                            <Form.Label>CIUDAD</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ CODIGO_CIUDAD_CLIENTE: e.target.value, NOMBRE_CIUDAD_CLIENTE: e.target.selectedOptions[0].innerText })} value={this.state.CODIGO_CIUDAD_CLIENTE} required>
                                                <option key='d' value="">--Seleccione Ciudad--</option>
                                                {ciudades.map(function (currentData, index) {
                                                    if (currentData.CODIGO_DEPARTAMENTO === currentDep) {
                                                        return <option key={'d' + index} value={currentData.CODIGO_DEPARTAMENTO + currentData.CODIGO_MUNICIPIO}>{currentData.NOMBRE_MUNICIPIO}</option>;
                                                    } else {
                                                        return null;
                                                    }
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>TELEFONO FIJO CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ TELEFONO_FIJO_CLIENTE: e.target.value })} value={this.state.TELEFONO_FIJO_CLIENTE} required />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>EMAIL CLIENTE</Form.Label>
                                            <Form.Control type="email" onChange={e => this.setState({ EMAIL_CLIENTE: e.target.value })} value={this.state.EMAIL_CLIENTE} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>ENVIAR COPIA A</Form.Label>
                                            <Form.Control type="email" onChange={e => this.setState({ ADDITIONA_EMAIL: e.target.value })} value={this.state.ADDITIONA_EMAIL} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>TIPO TERCERO</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ TIPO_TERCERO: e.target.value })} value={this.state.TIPO_TERCERO} required >
                                                <option value="">Seleccione</option>
                                                <option value="1">Persona Jurídica</option>
                                                <option value="2">Persona Natural</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>NOMBRE ESTABLECIMIENTO</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ NOMBRE_ESTABLECIMIENTO: e.target.value.toUpperCase() })} value={this.state.NOMBRE_ESTABLECIMIENTO} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>BARRIO CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ BARRIO_CLIENTE: e.target.value.toUpperCase() })} value={this.state.BARRIO_CLIENTE} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>TELEFONO CELULAR CLIENTE</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ TELEFONO_CELULAR_CLIENTE: e.target.value })} value={this.state.TELEFONO_CELULAR_CLIENTE} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>LISTA DE PRECIOS</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ LISTA_CLIENTE: e.target.value })} value={this.state.LISTA_CLIENTE}>
                                                <option value="">Seleccione</option>
                                                <option value="0">LISTA LIBRE</option>
                                                {listas.map(function (currentData, index) {
                                                    return <option key={'v' + index} value={currentData.ID_LISTA_PRECIOS}>{currentData.NOMBRE_LISTA}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>FORMA DE PAGO</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ FORMA_PAGO_CLIENTE: e.target.value })} value={this.state.FORMA_PAGO_CLIENTE}>
                                                <option value="">Seleccione</option>
                                                {forma_pago.map(function (currentData, index) {
                                                    return <option key={'v' + index} value={currentData.ID_FORMAS_PAGO}>{currentData.DESCRIPCION_FORMA_PAGO}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>CIIU</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ CIIU: e.target.value })} value={this.state.CIIU} required maxLength={4}/>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>ESTADO CLIENTE</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ ESTADO_CLIENTE: e.target.value })} value={this.state.ESTADO_CLIENTE} >
                                                <option value="0">Inactivo</option>
                                                <option value="1">Activo</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>VENDEDOR ASOCIADO</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ VENDEDOR_ASOCIADO: e.target.value })} value={this.state.VENDEDOR_ASOCIADO} >
                                                <option value="">Seleccione</option>
                                                {vendedores.map(function (currentData, index) {
                                                    return <option key={'v' + index} value={currentData.ID_VENDEDORES}>{currentData.NOMBRE_VENDEDOR}</option>;
                                                })}
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>CONTACTO COMPRA</Form.Label>
                                            <Form.Control type="text" onChange={e => this.setState({ CONTACTO_COMPRA: e.target.value.toUpperCase() })} value={this.state.CONTACTO_COMPRA} required />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>GRAN CONTRIBUYENTE</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ GRAN_CONTRIBUYENTE: e.target.value })} value={this.state.GRAN_CONTRIBUYENTE}>
                                                <option value="1">Si</option>
                                                <option value="0">No</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>LIQUIDA IVA</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ LIQUIDA_IVA: e.target.value })} value={this.state.LIQUIDA_IVA}>
                                                <option value="1">Si</option>
                                                <option value="0">No</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>LIQUIDA RENTA</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ LIQUIDA_RENTA: e.target.value })} value={this.state.LIQUIDA_RENTA}>
                                                <option value="1">Si</option>
                                                <option value="0">No</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>LIQUIDA RETEIVA</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ LIQUIDA_RETEIVA: e.target.value })} value={this.state.LIQUIDA_RETEIVA}>
                                                <option value="1">Si</option>
                                                <option value="0">No</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>LIQUIDA RETEICA</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ LIQUIDA_RETEICA: e.target.value })} value={this.state.LIQUIDA_RETEICA} >
                                                <option value="1">Si</option>
                                                <option value="0">No</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>LIQUIDA RETEOTROS</Form.Label>
                                            <Form.Control as="select" onChange={e => this.setState({ LIQUIDA_RETEOTROS: e.target.value })} value={this.state.LIQUIDA_RETEOTROS} >
                                                <option value="1">Si</option>
                                                <option value="0">No</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmpresa">
                                            <Form.Label>Regimen Fiscales</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ REGIMEN: e.target.value })} value={this.state.REGIMEN} required >
                                                <option value="">Seleccione</option>
                                                <option value="48">Responsable de IVA</option>
                                                <option value="49">No responsable de IVA</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    RESPONSABILIDADES FISCALES
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="O-13">
                                            <Form.Check type="checkbox" label="O-13 Gran Contribuyente" onChange={this.CheckedRespo} checked={this.state.O13} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="O-15">
                                            <Form.Check type="checkbox" label="O-15 Autorretenedor" onChange={this.CheckedRespo} checked={this.state.O15} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="O-23">
                                            <Form.Check type="checkbox" label="O-23 Agente de retencion IVA" onChange={this.CheckedRespo} checked={this.state.O23} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="O-47">
                                            <Form.Check type="checkbox" label="O-47 Regimen simple de tributacion" onChange={this.CheckedRespo} checked={this.state.O47} />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="R-99-PN">
                                            <Form.Check type="checkbox" label="R-99-PN No responsable" onChange={this.CheckedRespo} checked={this.state.R99} />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} controlId="">
                                            <Form.Label>OBSERVACIONES CLIENTE</Form.Label>
                                            <Form.Control as="textarea" rows="3" onChange={e => this.setState({ OBSERVACIONES_CLIENTE: e.target.value.toUpperCase() })} value={this.state.OBSERVACIONES_CLIENTE} />
                                        </Form.Group>
                                    </Form.Row>

                                    <Button variant="primary" type="submit">{mensajeBoton}</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </div>
                }
                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (Formularioclientes);